import { IDetailsItem } from '../components/KnmEpguNotification';
import { knmHistoryFields } from '../../KnmHistoriesModule/constants/knmHistoryFields';
import { IKnmHistoryField } from '../../KnmHistoriesModule/interfaces/IKnmHistoryField';

function onlyUnique<T>(value: T, index: number, array: T[]): boolean {
  return array.indexOf(value) === index;
}

function createDetailItem(path: string[], index?: number): IDetailsItem {
  const currentIndex = index || 1;
  const fieldName = path.slice(0, currentIndex).join('/');
  const historyField: IKnmHistoryField | undefined = knmHistoryFields[fieldName];

  return {
    value: historyField?.name,
    field: fieldName,
    items: currentIndex < path.length ? [createDetailItem(path, currentIndex + 1)] : undefined,
  };
}

function concatDetailItems(detailsItems: IDetailsItem[]): IDetailsItem[] {
  const fields: string[] = detailsItems.map(item => item.field).filter(onlyUnique);
  const result: IDetailsItem[] = [];

  fields.forEach(field => {
    const itemsByKey = detailsItems.filter(item => item.field === field);
    const value = itemsByKey[0]?.value;
    let items: IDetailsItem[] = [];

    itemsByKey.map(item => item.items).forEach(item => item && items.push(...item));
    if (items.length) {
      items = concatDetailItems(items);
    }
    result.push({
      field,
      value,
      items,
    });
  });

  return result;
}

export function createDetailsItems(structure: string[]): IDetailsItem[] {
  const result: IDetailsItem[] = [];

  structure.forEach(item => {
    const path = item.split('/');

    result.push(createDetailItem(path));
  });

  return concatDetailItems(result);
}
